module.exports = __webpack_public_path__ + "img/3_1_search.d7f012db.gif";